import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasProject from './aidas-project';
import AidasProjectDetail from './aidas-project-detail';
import AidasProjectUpdate from './aidas-project-update';
import AidasProjectDeleteDialog from './aidas-project-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasProjectUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasProjectUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasProjectDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasProject} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasProjectDeleteDialog} />
  </>
);

export default Routes;
